<template>
  <div class="searchQuery" id="searchQuery">
    <!--<div class="resize-line" id="resize-line"></div>-->
    <div :class="[queryStart ? 'searchQuery_max' : '']">
      <el-form label-position="right" label-width="70px" size="mini">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-row :gutter="20">
              <el-col :span="itme.key=='state'?24:8" v-for="(itme, key) in fromList" :key="key">
                <el-form-item :label="`${itme.label}`">
                  <el-input size="mini" v-if="itme.type === 'input'" v-model="fromData[itme.key]" clearable>
                    <template slot="append">
                      <p style="cursor: pointer; text-align: center;" @click="openDialog(itme.dialog, itme.code)"
                         v-if="itme.tips">{{itme.tips}}</p>
                    </template>
                  </el-input>
                  <el-select v-if="itme.type === 'select'"
                             v-model="fromData[itme.key]" :multiple="itme.multiple" filterable
                             placeholder="请选择">
                    <el-option
                      v-for="(val, index) in itme.valData"
                      :key="index"
                      :label="val[itme.labelVal]"
                      :value="val[itme.value]">
                      <!--v-show="fromData[itme.key].indexOf(val[itme.value]) === -1"-->
                    </el-option>
                  </el-select>
                  <el-checkbox-group v-if="itme.type === 'checkbox'" v-model="fromData[itme.key]">
                    <el-checkbox v-for="(val, index) in itme.valData"
                                 :key="index"
                                 :label="val[itme.value]">{{val[itme.labelVal]}}
                    </el-checkbox>
                  </el-checkbox-group>
                  <el-date-picker
                    v-if="itme.type === 'timeSelect'"
                    v-model="fromData[itme.key]"
                    align="right"
                    :clearable="false"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期"></el-date-picker>
                  <el-autocomplete
                    v-if="itme.type === 'inputCustom'"
                    v-model="fromData[itme.key]"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="inputSelectEven">
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.BLNO }}</div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4">
            <div class="searchQuery_query">
              <el-button class="mediumBtn" type="primary" size="medium" icon="el-icon-search" @click="queryEven">查询
              </el-button>
            </div>
            <p class="searchQuery_queryp" style="text-align: center;" v-if="queryStart">
              <span style="cursor:pointer;" @click="queryStart = !queryStart"><i class="el-icon-sort-down"/>展开</span>
            </p>
            <p class="searchQuery_queryp" style="text-align: center;" v-else>
              <span style="cursor:pointer;" @click="queryStart = !queryStart"><i class="el-icon-sort-up"/>收起</span></p>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <grid-dialog :show="showGuestId"
                 title="客户选择"
                 :default-params="guestIdDefaultParams"
                 :default-values.sync="guestIdDefaultValue"
                 :default-keys="guestIdDefaultKeys"
                 :ref-value.sync="fromData"
                 :grid-config="dictionaryAction"
                 @close="showGuestId = !showGuestId"></grid-dialog>
    <grid-dialog :show="showBargainID"
                 title="合同选择"
                 :default-params="bargainIDDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="bargainDefaultValue"
                 :default-keys="bargainDefaultKeys"
                 :ref-value.sync="fromData"
                 @close="showBargainID = !showBargainID"></grid-dialog>
    <grid-dialog :show="showGoodsID"
                 title="产品选择"
                 :default-params="refGoodsDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="goodsDefaultValue"
                 :default-keys="goodsDefaultKeys"
                 :ref-value.sync="fromData"
                 @close="showGoodsID = !showGoodsID"></grid-dialog>
    <grid-dialog :show="showgetTGuest"
                 title="提货人选择"
                 :default-params="TGuestIDDefaultParams"
                 :grid-config="dictionaryAction"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKey"
                 :ref-value.sync="fromData"
                 @close="showgetTGuest = !showgetTGuest"></grid-dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import gridDialog from '@/components/gridDialog';

  export default {
    name: 'customerServiceSearchQuery',
    components: {
      gridDialog,
    },
    props: {
      height: {
        request: true,
      },
      fromList: {
        request: true,
      },
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        goodDicList: 'dictionary/goodDicList',
        dictionaryAction: 'dictionary/dictionaryAction',
        guestIDByConditionsList: 'dictionary/TGuestIDByConditionsAction',
        bargainIDByConditionsList: 'dictionary/bargainIDByConditionsList',
        refGoodsByConditionsList: 'dictionary/refGoodsByConditionsList',
        TGuestIDByConditions: 'dictionary/TGuestIDByConditions',
      }),
      guestIdDefaultParams() {
        let sid = '';
        let params = {
          guestId: this.fromData.TGuestName,
        };
        let info = {
          type: 'BUSINESS',
          url: 'getVGuest',
          params,
        };
        return info;
      },
      bargainIDDefaultParams() {
        let params = {
          bargainId: this.fromData.bargainId ? this.fromData.bargainId : '',
          guestId: this.fromData.TGuestName ? this.fromData.vGuestId ? this.fromData.vGuestId : this.fromData.TGuestName : '',
        };
        let info = {
          type: 'BUSINESS',
          url: 'getBargain',
          params,
        };
        return info;
      },
      refGoodsDefaultParams() {
        let params = {
          bargainId: this.fromData.bargainId ? this.fromData.bargainId : '',
          guestId: this.fromData.TGuestName ? this.fromData.vGuestId ? this.fromData.vGuestId : this.fromData.TGuestName : '',
          goodsId: this.fromData.goodsName,
        };
        let info = {
          type: 'BUSINESS',
          url: 'getRefGoods',
          params,
        };
        return info;
      },
      TGuestIDDefaultParams() {
        let params = {
          guestId: this.fromData.Name ? this.fromData.tGuestId ? this.fromData.tGuestId : this.fromData.Name : '',
        };
        let info = {
          type: 'BUSINESS',
          url: 'getTGuest',
          params,
        };
        return info;
      },
      batchNumberCol() {
        let arr = [];
        this.carOrderBatch.forEach(itme => {
          let info = {field: itme.fieldName, title: itme.fieldAlias, width: itme.displayWidth, readOnly: itme.readOnly};
          arr.push(info);
        });
        return arr;
      },
      licenseNumberClo() {
        let arr = [];
        this.carOrderList.forEach(itme => {
          let info = {field: itme.fieldName, title: itme.fieldAlias, width: itme.displayWidth, readOnly: itme.readOnly};
          arr.push(info);
        });
        return arr;
      },
    },
    data() {
      return {
        queryStart: true,
        showGoodDic: false,
        labelPosition: true,
        defaultValue: {
          goodsId: '',
          goodsName: '',
        },
        billlist: [],
        billlistColor: [
          {
            label: '已创建',
            key: '0',
            color: '#80AB00',
          }, {
            label: '已操作完成',
            key: '1',
            color: '#0000FF',
          }, {
            label: '已有效',
            key: '90',
            color: '#8080FF',
          }, {
            label: '操作中',
            key: '91',
            color: '#804000',
          }, {
            label: '审核中',
            key: '99',
            color: '#008040',
          }, {
            label: '已完成',
            key: '100',
            color: '#000040',
          }, {
            label: '已作废',
            key: '-1',
            color: '#FF0000',
          },
        ],
        fromData: {
          serviceId: [true, true],
          state: ['0', '1', '90', '91'],
        },
        showGuestId: false,
        showBargainID: false,
        showGoodsID: false,
        showgetTGuest: false,
        guestIdDefaultValue: {
          GuestID: 'vGuestId',
          Name: 'TGuestName',
        },
        guestIdDefaultKeys: 'GuestID',
        goodsDefaultValue: {
          CEGoodsName: 'goodsName',
          GoodsID: 'goodsId',
        },
        goodsDefaultKeys: 'GoodsID',
        TGuestIDDefaultValue: {
          GuestID: 'tGuestId',
          Name: 'Name',
        },
        TGuestIDDefaultKey: 'GuestID',
        bargainDefaultValue: {
          BargainID: 'bargainId',
        },
        bargainDefaultCondition: [
          {
            label: '合同编号',
            key: 'bargainId',
            placeholder: '请输入合同编号',
            value: '',
          },
        ],
        bargainDefaultKeys: 'bargainId',
        carOrderBatchComponent: {
          select: ['TankID', 'BatchID'],
          checked: ['IsInTrade', 'IsOutTrade', 'IsTax'],
        },
        carOrderListComponent: {
          select: [],
          checked: ['IsDate'],
        },
        TGuestIDDefaultParamsCondition: [
          {
            label: '提货人编号',
            key: 'guestId',
            placeholder: '请输入提货人编号',
            value: '',
          },
        ],
      };
    },
    created() {
      this.fromList.forEach(itme => {
        this.$set(this.fromData, itme.key, '');
        if (itme.default) {
          this.fromData[itme.key] = itme.default;
        }
      });
      this.getGuestIDByConditionsList();
      this.getBargainIDByConditionsList();
      this.getRefGoodsByConditionsList();
      // this.getCarOrderBatch();
      this.getCarOrderList();
      this.getTGuestIDByConditions();
    },
    methods: {
      ...mapActions({
        getDictionaryAction: 'dictionary/getDictionaryAction',
        getGuestIDByConditionsList: 'dictionary/getTGuestIDByConditionsAction',
        getBargainIDByConditionsList: 'dictionary/getBargainIDByConditionsList',
        getRefGoodsByConditionsList: 'dictionary/getRefGoodsByConditionsList',
        getCarOrderBatch: 'dictionary/getCarOrderBatch',
        getCarOrderList: 'dictionary/getCarOrderList',
        getTGuestIDByConditions: 'dictionary/getTGuestIDByConditions',
      }),
      checkBox() {
        let change = false;
        this.fromList.forEach(itme => {
          if (itme.type === 'checkbox' || (itme.type === 'select' && itme.multiple)) {
            this.fromData[itme.key] = [];
            itme.valData.forEach(val => {
              if (val.ifChecked) {
                this.fromData[itme.key].push(val[itme.value]);
                change = true;
              }
            })
          }
        });
        // change ? this.$emit('queryEven') : '';
      },
      inputSelectEven(value) {
        this.fromData.blno = value.BLNO;
      },
      querySearch(queryString, cb) {
        let list = []
        this.fromList.forEach(itme => {
          if (itme.label === '提单号') {
            list = itme.valData
          }
        })
        let restaurants = list;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (restaurant.BLNO.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      openGoodDic() {
        this.showGoodDic = !this.showGoodDic;
      },
      queryEven() {
        this.fromList.every(v => {
          return (v.type === 'timeSelect' && this.fromData[v.key]) || v.type !== 'timeSelect';
        }) ? this.$emit('queryEven') : this.$message({
          message: '时间条件不可以为空！',
          type: 'warning',
        });
      },
      openDialog(key, code) {
        if (key === 'batch') {
          this.getInCarBatchId();
          return;
        }
        this.getDictionaryAction(code);
        this[key] = !this[key];
      },
      resizeSearch() {
        const resize = document.getElementById('resize-line');
        const searchQuery = document.getElementById('lading_conter_search');
        resize.onmousedown = e => {
          let startX = e.clientX;
          resize.left = resize.offsetLeft;
          document.onmousemove = e => {
            let endX = e.clientX;
            let moveLen = endX - startX;
            if (searchQuery.offsetWidth < 250 || searchQuery.offsetWidth > 500) return;
            if (searchQuery.offsetWidth - moveLen <= 250) return;
            if (searchQuery.offsetWidth - moveLen >= 500) return;
            searchQuery.style.width = (searchQuery.offsetWidth - moveLen) + 'px';
            startX = endX;

            let width = searchQuery.offsetWidth - moveLen;
            if (width < 320) this.labelPosition = false;
            else this.labelPosition = true;
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
            resize.releaseCapture && resize.releaseCapture();
          };
          resize.setCapture && resize.setCapture();
          return false;
        };
      },
    },
    watch: {
      fromList() {
        this.checkBox();
      }
    }
  };
</script>
<style lang="scss">
  .searchQuery {
    border-left: 0;
    position: relative;
    width: 100%;

    .el-form-item__label {
      padding-top: 0px;
    }

    .resize-line {
      height: 100%;
      width: 1px;
      background-color: #ebeef5;
      position: absolute;
      padding: 0 2px;
      left: -1px;
      top: 0;

      &:hover {
        cursor: w-resize;
      }
    }

    .searchQuery_query {
      height: 40px;
      button {
        padding: 8px 20px;
      }
    }
    .searchQuery_max {
      .el-row {
        overflow-y: hidden;
        height: 60px;
        margin: 0 !important;
      }
    }
    .el-autocomplete {
      width: 100%;
    }
  }

  .mediumBtn {
    padding: 10px 20px;
  }
</style>
